export var DTPluginToSupernovaMapType;
(function (DTPluginToSupernovaMapType) {
    DTPluginToSupernovaMapType["theme"] = "theme";
    DTPluginToSupernovaMapType["set"] = "set";
})(DTPluginToSupernovaMapType || (DTPluginToSupernovaMapType = {}));
export var DTPluginThemeOverrideStrategy;
(function (DTPluginThemeOverrideStrategy) {
    DTPluginThemeOverrideStrategy["default"] = "default";
    DTPluginThemeOverrideStrategy["aliasIsDifferent"] = "aliasIsDifferent";
})(DTPluginThemeOverrideStrategy || (DTPluginThemeOverrideStrategy = {}));
export var DTPluginPreciseCopyStrategy;
(function (DTPluginPreciseCopyStrategy) {
    DTPluginPreciseCopyStrategy["none"] = "none";
    DTPluginPreciseCopyStrategy["deleteAll"] = "deleteAll";
    DTPluginPreciseCopyStrategy["keepManualTokens"] = "keepManualTokens";
})(DTPluginPreciseCopyStrategy || (DTPluginPreciseCopyStrategy = {}));
export const isPreciseCopyEnabled = (preciseCopy) => preciseCopy !== DTPluginPreciseCopyStrategy.none;
export const toPreciseCopyStrategy = (preciseCopy) => {
    if (preciseCopy === true) {
        return DTPluginPreciseCopyStrategy.deleteAll;
    }
    if (!preciseCopy) {
        return DTPluginPreciseCopyStrategy.none;
    }
    return preciseCopy;
};
